import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModeFacturasMarcaslInterface, IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { VersionesService } from '../../services/versiones.service';


@Component({
  selector: 'app-upload-presu-propiedades',
  templateUrl: './upload-presu-propiedades.component.html',
  styleUrls: ['./upload-presu-propiedades.component.css']
})

export class UploadPresupuestoPropiedaesComponent implements OnInit {

  titulo = 'Carga de Presupuesto - Propiedades Jerarquias';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: IndicadoresVivosVModelInterface;
  modelGridFacturasMarcas: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  cmbOpcionesV2: any[] = [
    { clave: true, valor: 'SI' },
    { clave: false, valor: 'NO' }
  ]

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _catalogo: CatalogoIndicadoresService,
    private _indicadores: IndicadoresVivosService,
    private _versiones: VersionesService
  ) { }

  ngOnInit() {
    this.cmbOpciones = this._catalogo.catalogoOpciones();
    this.formulario = this.fb.group({
      opcion: ['', [Validators.required]],
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGrid();
    this.modelGridFacturasMarcas = innClase.devolverGridFacturasMarcas();

    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.getVersiones();
  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        field: 'anio',
        filter: true,
        width: 120,
        sortable: true
      },
      {
        field: 'mes',
        filter: true,
        width: 120,
        sortable: true
      },
      {
        field: 'codigoVendedor',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        field: 'material',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        field: 'jerarquia',
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'SubCategoria',
        field: 'jerarquiaDescripcion',
        filter: true,
        width: 270,
        sortable: true
      },
      {
        field: 'dolares',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        field: 'kilos',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        field: 'cajas',
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._indicadores.presupuestoPropiedadesUploadCSV(this.setFormData(this.formulario.value)),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      console.log("Proceso presupuesto propiedades",res);
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    const opcion = this.formulario.get('opcion').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de Presupuesto?',
        text: '',
        action: 'Guardar',
        funcion: this._indicadores.presupuestoPropiedadesUploadSave(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.downloadDataCsv();
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['ANIO', 'MES', 'VENDEDOR', 'ID_JERARQUIA', 'MATERIAL_REFERENCIA', 'CAJAS', 'KILOS', 'DOLARES']];
    const data: any[] = [
      { 'anio': '2021', 'mes': 9, 'vendedor': '3113', 'ID_JERARQUIA': '0010001', 'MATERIAL_REFERENCIA': '100001', 'CAJAS': '', 'KILOS':'', 'DOLARES':'100'}
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['ANIO', 'MES', 'VENDEDOR', 'NOM.VENDEDOR',  'ID_JERARQUIA', 'SUBCATEGORIA', 'MATERIAL_REFERENCIA', 'MATERIAL_REFERENCIA_NOMBRE', 'CAJAS', 'KILOS', 'DOLARES', 'Estado', 'Linea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.isCorrect) {
        data.push(
          {
            anio: (e.anio === undefined) ? '' : e.anio,
            mesDescripcion: (e.mes === undefined) ? '' : e.mes,
            codigoVendedor: (e.vendedor === undefined) ? '' : e.vendedor,
            nombreVendedor: (e.nombreVendedor === undefined) ? '' : e.nombreVendedor,
            jerarquia: (e.jerarquia === undefined) ? '' : e.jerarquia,
            subcategoria: (e.jerarquiaDescripcion === undefined) ? '' : e.jerarquiaDescripcion,
            matwrial: (e.material === undefined) ? '' : e.material,
            materialNombre: (e.materialDescripcion === undefined) ? '' : e.materialDescripcion,
            cajas: (e.cajas === undefined) ? '' : e.cajas,
            kilos: (e.kilos === undefined) ? '' : e.kilos,
            dolares: (e.dolares === undefined) ? '' : e.dolares,
            estado: (e.isCorrect) ? 'CORRECTO' : 'INCORRECTO',
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  listaDeVersiones;

  getVersiones() {
    this.loading = true;
    this._versiones.getVersiones().subscribe((res: any) => {
      console.log("getVersionActiva()", res)
      this.loading = false;
      this.listaDeVersiones = res.filter(t=>t.estado === 'A');

      for (let index = 0; index < this.listaDeVersiones.length; index++) {
        this.listaDeVersiones[index].versionNombre = this.listaDeVersiones[index].version +" - " +this.listaDeVersiones[index].nombre
      }

      this.formulario.get('opcion').setValue(this.listaDeVersiones.filter(t=>t.estado === 'A')[0].id);
      this.formulario.get('opcion').disable();
    }, (err) => {
      this.loading = false;
      this.listaDeVersiones = '';
    });
  }

}
